import { combineReducers } from "redux";

// Reducers
import banners from "./banners";
import billingAddress from "./billingAddress";
import cart from "./cart";
import category from "./category";
import checkout from "./checkout";
import content from "./content";
import enews from "./enews";
import locations from "./locations";
import product from "./product";
import productVariant from "./productVariant";
import route from "./route";
import saleCodes from "./saleCodes";
import shippingAddress from "./shippingAddress";
import shippingPayment from "./shippingPayment";
import pickup from "./pickup";
import siteInfo from "./siteInfo";
import sort from "./sort";
import storeLocation from "./storeLocation";
import suggestedProducts from "./suggestedProducts";
import user from "./user";

import persist from "./persist";

// Combine reducers
const rootReducer = combineReducers({
	banners,
	billingAddress,
	cart,
	category,
	checkout,
	content,
	enews,
	locations,
	persist,
	pickup,
	product,
	productVariant,
	route,
	saleCodes,
	shippingAddress,
	shippingPayment,
	siteInfo,
	sort,
	storeLocation,
	suggestedProducts,
	user
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js